export const TRANSACTION_TIMEOUT_S = 60 * 10; // 10 minutes in seconds
